<template>
	<div>
		<van-nav-bar
			title="房产信息"
			left-arrow
			@click-left="toSales"
		/>
		<van-tabs v-model="building">
			<van-tab v-for="building in houses" :key="building.bldNo" :title="building.bldName">
				<van-tabs v-model="cell">
					<van-tab v-for="cell in building.cells" :key="cell.cellNo" :title="cell.cellName">
						<van-panel v-for="floor in cell.floors" :key="floor.floorNo">
							<bv-floor slot="header" :title="floor.floorName" :summary="floor"/>
							<div class="flex">
								<bv-house v-for="room in floor.rooms" :key="room.roomId" :title="room.roomName" :area="room.area" :price="room.price"/>
							</div>
						</van-panel>
					</van-tab>
				</van-tabs>
			</van-tab>
		</van-tabs>
	</div>
</template>

<script>
	import {NavBar, Tabs, Tab, Panel} from 'vant'
	import Floor from '../components/Floor'
	import House from '../components/House'
	//import {fetchHouses} from '@/api/houseResource/house'

	export default {
		name: 'Building',
		components: {
			VanNavBar: NavBar,
			VanTabs: Tabs,
			VanTab: Tab,
			VanPanel: Panel,
			BvFloor: Floor,
			BvHouse: House
		},
		data() {
			return {
				building: null,
				cell: null,
				houses: []
			}
		},
		methods: {
			toSales() {
				this.$router.push('/houseResource/sales')
			}
		},
		// mounted() {
		// 	fetchHouses().then(res => {
		// 		this.houses = res.data
		// 	})
		// }
	}
</script>

